import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function camelize(value) {
  return value.replace(/(?:[_-])([a-z0-9])/g, function (_, char) {
    return char.toUpperCase();
  });
}

function capitalize(value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

function dasherize(value) {
  return value.replace(/([A-Z])/g, function (_, char) {
    return "-".concat(char.toLowerCase());
  });
}

function readInheritableStaticArrayValues(constructor, propertyName) {
  var ancestors = getAncestorsForConstructor(constructor);
  return Array.from(ancestors.reduce(function (values, constructor) {
    getOwnStaticArrayValues(constructor, propertyName).forEach(function (name) {
      return values.add(name);
    });
    return values;
  }, new Set()));
}

function readInheritableStaticObjectPairs(constructor, propertyName) {
  var ancestors = getAncestorsForConstructor(constructor);
  return ancestors.reduce(function (pairs, constructor) {
    pairs.push.apply(pairs, _toConsumableArray(getOwnStaticObjectPairs(constructor, propertyName)));
    return pairs;
  }, []);
}

function getAncestorsForConstructor(constructor) {
  var ancestors = [];

  while (constructor) {
    ancestors.push(constructor);
    constructor = Object.getPrototypeOf(constructor);
  }

  return ancestors.reverse();
}

function getOwnStaticArrayValues(constructor, propertyName) {
  var definition = constructor[propertyName];
  return Array.isArray(definition) ? definition : [];
}

function getOwnStaticObjectPairs(constructor, propertyName) {
  var definition = constructor[propertyName];
  return definition ? Object.keys(definition).map(function (key) {
    return [key, definition[key]];
  }) : [];
}

(function () {
  function extendWithReflect(constructor) {
    function extended() {
      return Reflect.construct(constructor, arguments, this instanceof extended ? this.constructor : void 0);
    }

    extended.prototype = Object.create(constructor.prototype, {
      constructor: {
        value: extended
      }
    });
    Reflect.setPrototypeOf(extended, constructor);
    return extended;
  }

  function testReflectExtension() {
    var a = function a() {
      this.a.call(this);
    };

    var b = extendWithReflect(a);

    b.prototype.a = function () {};

    return new b();
  }

  try {
    testReflectExtension();
    return extendWithReflect;
  } catch (error) {
    return function (constructor) {
      return /*#__PURE__*/function (_constructor) {
        _inherits(extended, _constructor);

        var _super = _createSuper(extended);

        function extended() {
          _classCallCheck(this, extended);

          return _super.apply(this, arguments);
        }

        return extended;
      }(constructor);
    };
  }
})();

function ClassPropertiesBlessing(constructor) {
  var classes = readInheritableStaticArrayValues(constructor, "classes");
  return classes.reduce(function (properties, classDefinition) {
    return Object.assign(properties, propertiesForClassDefinition(classDefinition));
  }, {});
}

function propertiesForClassDefinition(key) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, "".concat(key, "Class"), {
    get: function get() {
      var classes = this.classes;

      if (classes.has(key)) {
        return classes.get(key);
      } else {
        var attribute = classes.getAttributeName(key);
        throw new Error("Missing attribute \"".concat(attribute, "\""));
      }
    }
  }), _defineProperty(_ref, "".concat(key, "Classes"), {
    get: function get() {
      return this.classes.getAll(key);
    }
  }), _defineProperty(_ref, "has".concat(capitalize(key), "Class"), {
    get: function get() {
      return this.classes.has(key);
    }
  }), _ref;
}

function TargetPropertiesBlessing(constructor) {
  var targets = readInheritableStaticArrayValues(constructor, "targets");
  return targets.reduce(function (properties, targetDefinition) {
    return Object.assign(properties, propertiesForTargetDefinition(targetDefinition));
  }, {});
}

function propertiesForTargetDefinition(name) {
  var _ref2;

  return _ref2 = {}, _defineProperty(_ref2, "".concat(name, "Target"), {
    get: function get() {
      var target = this.targets.find(name);

      if (target) {
        return target;
      } else {
        throw new Error("Missing target element \"".concat(name, "\" for \"").concat(this.identifier, "\" controller"));
      }
    }
  }), _defineProperty(_ref2, "".concat(name, "Targets"), {
    get: function get() {
      return this.targets.findAll(name);
    }
  }), _defineProperty(_ref2, "has".concat(capitalize(name), "Target"), {
    get: function get() {
      return this.targets.has(name);
    }
  }), _ref2;
}

function ValuePropertiesBlessing(constructor) {
  var valueDefinitionPairs = readInheritableStaticObjectPairs(constructor, "values");
  var propertyDescriptorMap = {
    valueDescriptorMap: {
      get: function get() {
        var _this = this;

        return valueDefinitionPairs.reduce(function (result, valueDefinitionPair) {
          var valueDescriptor = parseValueDefinitionPair(valueDefinitionPair);

          var attributeName = _this.data.getAttributeNameForKey(valueDescriptor.key);

          return Object.assign(result, _defineProperty({}, attributeName, valueDescriptor));
        }, {});
      }
    }
  };
  return valueDefinitionPairs.reduce(function (properties, valueDefinitionPair) {
    return Object.assign(properties, propertiesForValueDefinitionPair(valueDefinitionPair));
  }, propertyDescriptorMap);
}

function propertiesForValueDefinitionPair(valueDefinitionPair) {
  var _ref3;

  var definition = parseValueDefinitionPair(valueDefinitionPair);
  var key = definition.key,
      name = definition.name,
      read = definition.reader,
      write = definition.writer;
  return _ref3 = {}, _defineProperty(_ref3, name, {
    get: function get() {
      var value = this.data.get(key);

      if (value !== null) {
        return read(value);
      } else {
        return definition.defaultValue;
      }
    },
    set: function set(value) {
      if (value === undefined) {
        this.data.delete(key);
      } else {
        this.data.set(key, write(value));
      }
    }
  }), _defineProperty(_ref3, "has".concat(capitalize(name)), {
    get: function get() {
      return this.data.has(key) || definition.hasCustomDefaultValue;
    }
  }), _ref3;
}

function parseValueDefinitionPair(_ref4) {
  var _ref5 = _slicedToArray(_ref4, 2),
      token = _ref5[0],
      typeDefinition = _ref5[1];

  return valueDescriptorForTokenAndTypeDefinition(token, typeDefinition);
}

function parseValueTypeConstant(constant) {
  switch (constant) {
    case Array:
      return "array";

    case Boolean:
      return "boolean";

    case Number:
      return "number";

    case Object:
      return "object";

    case String:
      return "string";
  }
}

function parseValueTypeDefault(defaultValue) {
  switch (_typeof(defaultValue)) {
    case "boolean":
      return "boolean";

    case "number":
      return "number";

    case "string":
      return "string";
  }

  if (Array.isArray(defaultValue)) return "array";
  if (Object.prototype.toString.call(defaultValue) === "[object Object]") return "object";
}

function parseValueTypeObject(typeObject) {
  var typeFromObject = parseValueTypeConstant(typeObject.type);

  if (typeFromObject) {
    var defaultValueType = parseValueTypeDefault(typeObject.default);

    if (typeFromObject !== defaultValueType) {
      throw new Error("Type \"".concat(typeFromObject, "\" must match the type of the default value. Given default value: \"").concat(typeObject.default, "\" as \"").concat(defaultValueType, "\""));
    }

    return typeFromObject;
  }
}

function parseValueTypeDefinition(typeDefinition) {
  var typeFromObject = parseValueTypeObject(typeDefinition);
  var typeFromDefaultValue = parseValueTypeDefault(typeDefinition);
  var typeFromConstant = parseValueTypeConstant(typeDefinition);
  var type = typeFromObject || typeFromDefaultValue || typeFromConstant;
  if (type) return type;
  throw new Error("Unknown value type \"".concat(typeDefinition, "\""));
}

function defaultValueForDefinition(typeDefinition) {
  var constant = parseValueTypeConstant(typeDefinition);
  if (constant) return defaultValuesByType[constant];
  var defaultValue = typeDefinition.default;
  if (defaultValue !== undefined) return defaultValue;
  return typeDefinition;
}

function valueDescriptorForTokenAndTypeDefinition(token, typeDefinition) {
  var key = "".concat(dasherize(token), "-value");
  var type = parseValueTypeDefinition(typeDefinition);
  return {
    type: type,
    key: key,
    name: camelize(key),

    get defaultValue() {
      return defaultValueForDefinition(typeDefinition);
    },

    get hasCustomDefaultValue() {
      return parseValueTypeDefault(typeDefinition) !== undefined;
    },

    reader: readers[type],
    writer: writers[type] || writers.default
  };
}

var defaultValuesByType = {
  get array() {
    return [];
  },

  boolean: false,
  number: 0,

  get object() {
    return {};
  },

  string: ""
};
var readers = {
  array: function array(value) {
    var array = JSON.parse(value);

    if (!Array.isArray(array)) {
      throw new TypeError("Expected array");
    }

    return array;
  },
  boolean: function boolean(value) {
    return !(value == "0" || value == "false");
  },
  number: function number(value) {
    return Number(value);
  },
  object: function object(value) {
    var object = JSON.parse(value);

    if (object === null || _typeof(object) != "object" || Array.isArray(object)) {
      throw new TypeError("Expected object");
    }

    return object;
  },
  string: function string(value) {
    return value;
  }
};
var writers = {
  default: writeString,
  array: writeJSON,
  object: writeJSON
};

function writeJSON(value) {
  return JSON.stringify(value);
}

function writeString(value) {
  return "".concat(value);
}

var Controller = /*#__PURE__*/function () {
  function Controller(context) {
    _classCallCheck(this, Controller);

    this.context = context;
  }

  _createClass(Controller, [{
    key: "application",
    get: function get() {
      return this.context.application;
    }
  }, {
    key: "scope",
    get: function get() {
      return this.context.scope;
    }
  }, {
    key: "element",
    get: function get() {
      return this.scope.element;
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.scope.identifier;
    }
  }, {
    key: "targets",
    get: function get() {
      return this.scope.targets;
    }
  }, {
    key: "classes",
    get: function get() {
      return this.scope.classes;
    }
  }, {
    key: "data",
    get: function get() {
      return this.scope.data;
    }
  }, {
    key: "initialize",
    value: function initialize() {}
  }, {
    key: "connect",
    value: function connect() {}
  }, {
    key: "disconnect",
    value: function disconnect() {}
  }, {
    key: "dispatch",
    value: function dispatch(eventName) {
      var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref6$target = _ref6.target,
          target = _ref6$target === void 0 ? this.element : _ref6$target,
          _ref6$detail = _ref6.detail,
          detail = _ref6$detail === void 0 ? {} : _ref6$detail,
          _ref6$prefix = _ref6.prefix,
          prefix = _ref6$prefix === void 0 ? this.identifier : _ref6$prefix,
          _ref6$bubbles = _ref6.bubbles,
          bubbles = _ref6$bubbles === void 0 ? true : _ref6$bubbles,
          _ref6$cancelable = _ref6.cancelable,
          cancelable = _ref6$cancelable === void 0 ? true : _ref6$cancelable;

      var type = prefix ? "".concat(prefix, ":").concat(eventName) : eventName;
      var event = new CustomEvent(type, {
        detail: detail,
        bubbles: bubbles,
        cancelable: cancelable
      });
      target.dispatchEvent(event);
      return event;
    }
  }], [{
    key: "shouldLoad",
    get: function get() {
      return true;
    }
  }]);

  return Controller;
}();

Controller.blessings = [ClassPropertiesBlessing, TargetPropertiesBlessing, ValuePropertiesBlessing];
Controller.targets = [];
Controller.values = {};

var RevealController = /*#__PURE__*/function (_Controller) {
  _inherits(RevealController, _Controller);

  var _super2 = _createSuper(RevealController);

  function RevealController() {
    _classCallCheck(this, RevealController);

    return _super2.apply(this, arguments);
  }

  _createClass(RevealController, [{
    key: "connect",
    value: function connect() {
      this._initCloseKeypressListener();

      this._initToggleKeypressListener();

      this._initShowKeypressListener();

      this._awayHandler = this._awayHandler.bind(this);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this._teardown();
    }
  }, {
    key: "show",
    value: function show(event) {
      if (this.openValue || this.transitioningValue) return;

      this._init(event, true);
    }
  }, {
    key: "hide",
    value: function hide(event) {
      if (!this.openValue || this.transitioningValue) return;

      this._init(event, false);
    }
  }, {
    key: "toggle",
    value: function toggle(event) {
      if (this.transitioningValue) return;

      this._init(event, !this.openValue);
    }
  }, {
    key: "stop",
    value: function stop(event) {
      event.stopPropagation();
    }
  }, {
    key: "_init",
    value: function () {
      var _init2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event, shouldOpen) {
        var startSelector, startPromises, defaultSelector, defaultPromises, endSelector, endPromises;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (event && event.currentTarget && event.currentTarget.dataset) {
                  if ("revealPreventDefault" in event.currentTarget.dataset) {
                    event.preventDefault();
                  }

                  if ("revealStopPropagation" in event.currentTarget.dataset) {
                    event.stopPropagation();
                  }
                }

                startSelector = "".concat(this.selector, "[data-").concat(shouldOpen ? "enter" : "leave", "-start]");
                startPromises = this._didInitWithPromise(startSelector, shouldOpen);
                _context.next = 5;
                return Promise.all(startPromises);

              case 5:
                defaultSelector = "".concat(this.selector, ":not([data-").concat(shouldOpen ? "enter" : "leave", "-start]):not([data-").concat(shouldOpen ? "enter" : "leave", "-end])");
                defaultPromises = this._didInitWithPromise(defaultSelector, shouldOpen);
                _context.next = 9;
                return Promise.all(defaultPromises);

              case 9:
                endSelector = "".concat(this.selector, "[data-").concat(shouldOpen ? "enter" : "leave", "-end]");
                endPromises = this._didInitWithPromise(endSelector, shouldOpen);
                _context.next = 13;
                return Promise.all(endPromises);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _init(_x, _x2) {
        return _init2.apply(this, arguments);
      }

      return _init;
    }()
  }, {
    key: "_teardown",
    value: function _teardown() {
      if (this.hasAwayValue) {
        document.removeEventListener("click", this._awayHandler);
      }
    }
  }, {
    key: "_didInitWithPromise",
    value: function _didInitWithPromise(selector, shouldOpen) {
      var _this2 = this;

      this._debug("selecting", selector, this._fetchElements(selector));

      return this._fetchElements(selector).map(function (element) {
        return _this2._doInitTransition(element, shouldOpen);
      });
    }
  }, {
    key: "_initCloseKeypressListener",
    value: function _initCloseKeypressListener() {
      var _this3 = this;

      if (this.hasHideKeysValue) {
        document.addEventListener("keydown", function (event) {
          if (!_this3.openValue) return;

          if (!_this3.hideKeysValue.split(",").includes(event.key.toLowerCase())) {
            return;
          }

          event.stopPropagation();

          _this3.toggle(event);
        });
      }
    }
  }, {
    key: "_initToggleKeypressListener",
    value: function _initToggleKeypressListener() {
      var _this4 = this;

      if (this.hasToggleKeysValue) {
        document.addEventListener("keydown", function (event) {
          if (!_this4.toggleKeysValue.split(",").includes(event.key.toLowerCase())) {
            return;
          }

          event.stopPropagation();

          _this4.toggle(event);
        });
      }
    }
  }, {
    key: "_initShowKeypressListener",
    value: function _initShowKeypressListener() {
      var _this5 = this;

      if (this.hasShowKeysValue) {
        document.addEventListener("keydown", function (event) {
          if (_this5.openValue) return;

          if (!_this5.showKeysValue.split(",").includes(event.key.toLowerCase())) {
            return;
          }

          event.stopPropagation();

          _this5.toggle(event);
        });
      }
    }
  }, {
    key: "_awayHandler",
    value: function _awayHandler(event) {
      if (!this.element.contains(event.target)) {
        document.removeEventListener("click", this._awayHandler);
        this.hide(event);
      }

      return true;
    }
  }, {
    key: "_doInitTransition",
    value: function _doInitTransition(target, openState) {
      var _this6 = this;

      this._debug("init transition", "".concat(openState ? "open" : "closed"), target);

      this._debug("dispatching event", "reveal:".concat(openState ? "show" : "hide"), target);

      target.dispatchEvent(new Event("reveal:".concat(openState ? "show" : "hide"), {
        bubbles: true,
        cancelable: false
      }));
      return new Promise(function (resolve, reject) {
        if ("transition" in target.dataset && _this6.element.offsetParent !== null) {
          requestAnimationFrame(function () {
            _this6._transitionSetup(target, openState);

            var _didEndTransition = _this6._didEndTransition.bind(_this6);

            target.addEventListener("transitionend", function _didEndTransitionHandler() {
              _didEndTransition(target, openState);

              target.removeEventListener("transitionend", _didEndTransitionHandler);
              resolve();
            });
            requestAnimationFrame(function () {
              _this6._doStartTransition(target, openState);
            });
          });
        } else {
          if (openState) {
            _this6._debug("force hidden - init", "".concat(openState ? "open" : "closed"), target);

            target.hidden = !target.hidden;
          }

          _this6._doCompleteTransition(target, openState);

          resolve();
        }
      });
    }
  }, {
    key: "_doStartTransition",
    value: function _doStartTransition(target, openState) {
      this._debug("start transition", "".concat(openState ? "open" : "closed"), target);

      this.transitioningValue = true;

      if (target.dataset.useTransitionClasses === "true") {
        var _target$classList, _target$classList2;

        var transitionClasses = this._transitionClasses(target, this.transitionType);

        (_target$classList = target.classList).add.apply(_target$classList, _toConsumableArray(transitionClasses.end.split(" ")));

        (_target$classList2 = target.classList).remove.apply(_target$classList2, _toConsumableArray(transitionClasses.start.split(" ")));
      } else {
        var transitions = this._transitionDefaults(openState);

        target.style.transformOrigin = transitions.origin;
        target.style.transitionProperty = "opacity transform";
        target.style.transitionDuration = "".concat(transitions.duration / 1e3, "s");
        target.style.transitionTimingFunction = "cubic-bezier(0.4, 0.0, 0.2, 1)";
        target.style.opacity = transitions.to.opacity;
        target.style.transform = "scale(".concat(transitions.to.scale / 100, ")");
      }
    }
  }, {
    key: "_didEndTransition",
    value: function _didEndTransition(target, openState) {
      this._debug("end transition", "".concat(openState ? "open" : "closed"), target);

      if (target.dataset.useTransitionClasses === "true") {
        var _target$classList3;

        var transitionClasses = this._transitionClasses(target, this.transitionType);

        (_target$classList3 = target.classList).remove.apply(_target$classList3, _toConsumableArray(transitionClasses.before.split(" ")));
      } else {
        target.style.opacity = target.dataset.opacityCache;
        target.style.transform = target.dataset.transformCache;
        target.style.transformOrigin = target.dataset.transformOriginCache;
      }

      this._doCompleteTransition(target, openState);
    }
  }, {
    key: "_doCompleteTransition",
    value: function _doCompleteTransition(target, openState) {
      this._debug("complete transition", "".concat(openState ? "open" : "closed"), target);

      this.transitioningValue = false;

      if (!openState) {
        this._debug("force hidden - complete", "".concat(openState ? "open" : "closed"), target);

        target.hidden = !target.hidden;
      }

      this.openValue = openState;

      this._debug("dispatching event", "reveal:".concat(openState ? "shown" : "hidden"), target);

      target.dispatchEvent(new Event("reveal:".concat(openState ? "shown" : "hidden"), {
        bubbles: true,
        cancelable: false
      }));

      if (this.hasAwayValue && openState) {
        document.addEventListener("click", this._awayHandler);
      }

      this._debug("dispatching event", "reveal:complete", target);

      target.dispatchEvent(new Event("reveal:complete", {
        bubbles: true,
        cancelable: false
      }));
    }
  }, {
    key: "_transitionSetup",
    value: function _transitionSetup(target, openState) {
      this.transitionType = openState ? "transitionEnter" : "transitionLeave";

      if (this.transitionType in target.dataset) {
        var _target$classList4, _target$classList5;

        target.dataset.useTransitionClasses = true;

        var transitionClasses = this._transitionClasses(target, this.transitionType);

        (_target$classList4 = target.classList).add.apply(_target$classList4, _toConsumableArray(transitionClasses.before.split(" ")));

        (_target$classList5 = target.classList).add.apply(_target$classList5, _toConsumableArray(transitionClasses.start.split(" ")));
      } else {
        target.dataset.useTransitionClasses = false;

        var transitions = this._transitionDefaults(openState);

        target.dataset.opacityCache = target.style.opacity;
        target.dataset.transformCache = target.style.transform;
        target.dataset.transformOriginCache = target.style.transformOrigin;
        target.style.opacity = transitions.from.opacity;
        target.style.transform = "scale(".concat(transitions.from.scale / 100, ")");
      }

      if (openState) {
        this._debug("opening with transition", target);

        target.hidden = !target.hidden;
      }
    }
  }, {
    key: "_transitionDefaults",
    value: function _transitionDefaults(openState) {
      return {
        duration: openState ? 200 : 150,
        origin: "center",
        from: {
          opacity: openState ? 0 : 1,
          scale: openState ? 95 : 100
        },
        to: {
          opacity: openState ? 1 : 0,
          scale: openState ? 100 : 95
        }
      };
    }
  }, {
    key: "_transitionClasses",
    value: function _transitionClasses(target, transitionType) {
      return {
        before: target.dataset[transitionType],
        start: target.dataset["".concat(transitionType, "Start")],
        end: target.dataset["".concat(transitionType, "End")]
      };
    }
  }, {
    key: "_fetchElements",
    value: function _fetchElements(selector) {
      return [this.element].concat(_toConsumableArray(this.element.querySelectorAll(selector))).filter(function (el) {
        return el.matches(selector);
      });
    }
  }, {
    key: "_debug",
    value: function _debug() {
      var _console;

      if (this.debugValue) (_console = console).log.apply(_console, arguments);
    }
  }, {
    key: "selector",
    get: function get() {
      return this.hasTargetSelectorValue ? this.targetSelectorValue : "[data-reveal]";
    }
  }]);

  return RevealController;
}(Controller);

RevealController.values = {
  open: Boolean,
  transitioning: Boolean,
  targetSelector: String,
  toggleKeys: String,
  showKeys: String,
  hideKeys: String,
  away: Boolean,
  debug: Boolean
};
export { RevealController as default };